import classNames from "classnames";
import { get } from "lodash";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PropertyFieldProps } from "../property";
import css from "./properties_fields.module.scss";

export const InputField = ({
  fieldName,
  label,
  required,
  type,
  disabled,
  validate,
  className
}: PropertyFieldProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const { t } = useTranslation("saasAdmin");

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: required && t("filtersConfig.errors.required"),
        validate: (value) => validate?.(value) || true
      }}
      render={({ field }) => (
        <InputFieldSet
          label={label}
          inputType={type === "number" ? "number" : "text"}
          kind="bordered"
          name={field.name}
          value={field.value}
          error={get(errors, [field.name, "message"])}
          onChange={field.onChange}
          onBlur={field.onBlur}
          required={required}
          className={classNames(css.inputField, className)}
          disabled={disabled}
        />
      )}
    />
  );
};
